import { render, staticRenderFns } from "./PageSeparatorComponent.vue?vue&type=template&id=26731e55&scoped=true&"
import script from "./PageSeparatorComponent.vue?vue&type=script&lang=js&"
export * from "./PageSeparatorComponent.vue?vue&type=script&lang=js&"
import style0 from "./PageSeparatorComponent.vue?vue&type=style&index=0&id=26731e55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26731e55",
  null
  
)

export default component.exports